import {
  Box,
  ComponentMultiStyleConfig,
  Icon,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";
import { MdError } from "react-icons/md";
import { IconType } from "react-icons";

export type CMMessageErrorProps = {
  icon?: IconType;
  labels: string[];
} & ComponentStyleProps;

/**
 * 情報メッセージコンポーネント.
 */
export const CMMessageError = ({
  icon = MdError,
  labels,

  sx,
  ...rest
}: CMMessageErrorProps) => {
  const styles = useMultiStyleConfig("CMMessageErrorStyles", {});

  return (
    <Box {...rest} sx={{ ...styles.container, ...sx }}>
      <Icon as={icon} sx={styles.icon} />
      <Box sx={styles.labels}>
        {labels.map((label, index) => (
          <Text key={index} sx={styles.label}>
            {label}
          </Text>
        ))}
      </Box>
    </Box>
  );
};

export const CMMessageErrorStyles: ComponentMultiStyleConfig = {
  parts: ["container", "icon", "labels", "label"],
  baseStyle: {
    container: {
      background: "red.100",
      display: "flex",
      alignItems: "flex-start",
      borderRadius: "6px",
      p: "14px 18px",
    },
    icon: {
      mr: "8px",
      w: "20px",
      h: "20px",
      color: "red.500",
    },
    labels: {
      display: "flex",
      flexFlow: "column nowrap",
      alignItems: "flex-start",
    },
    label: {
      fontWeight: "400",
      fontSize: "15px",
      color: "gray.700",
    },
  },
};
